<template>
  <div>
    <h1 class="flex pb-4 text-lg font-extrabold border-b border-yellow-300 text-primary">
      <span
        v-if="referrer === 'sign-up'"
        class="mr-2"
      >Je suis un professionnel du chiffre ou du droit,</span><span>{{ title }}</span>
    </h1>

    <t-alert
      v-if="errorMessage"
      class="mt-8"
    >
      {{ errorMessage }}
    </t-alert>

    <form
      class="mt-12"
      @submit.prevent="signUp"
    >
      <div class="grid grid-cols-2 gap-8">
        <div class="col-span-1">
          <div class="input required">
            <label for="account-fullname">Nom complet</label>
            <input
              id="account-fullname"
              v-model="account.fullName"
              type="text"
              required
              placeholder="Entrez votre prénom et nom"
            >
            <div
              v-if="errors.fullName"
              class="error"
            >
              {{ errors.fullName }}
            </div>
          </div>
        </div>
        <div class="col-span-1">
          <RcsInput
            :show-input="referrer === 'sign-up'"
            @pappers-data="fillForm"
          />

          <div class="input required">
            <label for="account-company">Nom de la société</label>
            <input
              id="account-company"
              v-model="account.companyName"
              type="text"
              required
              placeholder="Entrez le nom de votre société"
            >
            <div
              v-if="errors.companyName"
              class="error"
            >
              {{ errors.companyName }}
            </div>
            <div class="hint">
              Cette information sera reprise lors de la facturation.
            </div>
          </div>
        </div>
        <div class="col-span-1">
          <div class="input required">
            <label for="account-email">Adresse Email</label>
            <input
              id="account-email"
              v-model="account.email"
              type="email"
              required
              placeholder="Entrez votre adresse email"
            >
            <div
              v-if="errors.email"
              class="error"
            >
              {{ errors.email }}
            </div>
          </div>
        </div>
        <div class="col-span-1">
          <div class="input required">
            <label for="account-phone-number">Numéro de téléphone</label>
            <input
              id="account-phone-number"
              v-model="account.phoneNumber"
              type="text"
              required
              placeholder="Entrez votre numéro de téléphone"
              @keypress="checkInput"
            >
            <div
              v-if="phoneNumbersOnly"
              class="text-sm text-red-500"
            >
              Chiffres uniquement
            </div>
            <div
              v-if="errors.phoneNumber"
              class="error"
            >
              {{ errors.phoneNumber }}
            </div>
          </div>
        </div>
        <div class="col-span-1">
          <div class="input required">
            <label for="account-password">Mot de passe</label>
            <input
              id="account-password"
              v-model="account.password"
              type="password"
              required
              placeholder="Entrez votre mot de passe"
            >
            <div
              v-if="errors.password"
              class="error"
            >
              {{ errors.password }}
            </div>
          </div>
        </div>
        <div class="col-span-1">
          <div class="input required">
            <label for="account-password-confirmation">Confirmation Mot de passe</label>
            <input
              id="account-password-confirmation"
              v-model="account.passwordConfirmation"
              type="password"
              required
              placeholder="Entrez la confirmation du mot de passe"
            >
            <div
              v-if="errors.passwordConfirmation"
              class="error"
            >
              {{ errors.passwordConfirmation }}
            </div>
          </div>
        </div>
      </div>

      <div class="mt-12 text-right">
        <t-submit-button
          :button-state="buttonState"
          :labels="buttonLabels"
        />
      </div>
    </form>
  </div>
</template>

<script>
import RcsInput from '@/components/shared/rcs-input.vue';
import * as AuthService from '@/services/authentication';
import { CustomModal } from '@/components/shared/modals';
import { toCamel } from '@/shared/utils';
import { numbersOnly } from '@/helpers';

export default {
  name: 'AuthSignUp',
  components: { RcsInput },
  props: {
    title: { type: String, required: false, default: 'je crée un compte pro' },
    buttonLabels: {
      type: Object,
      required: false,
      default: () => ({
        default: "S'inscrire",
        inProgress: "En cours...",
        success: "Compte crée !",
        fail: "Échec",
      }),
    },
    referrer: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      errorMessage: false,
      errors: {},
      account: {
        fullName: null,
        companyName: null,
        companyRegistrationNumber: null,
        email: null,
        phoneNumber: null,
        password: null,
        passwordConfirmation: null
      },
      buttonState: 'default',
      phoneNumbersOnly: false
    };
  },
  methods: {
    signUp() {
      const isProfessional = this.referrer === 'sign-up';
      event.preventDefault();
      this.resetForm(false);
      AuthService.signUp(this.account, isProfessional)
      .then(account => this.onSuccess(account))
      .then(() => this.showModal())
      .catch(exception => this.onError(exception.response?.data?.errors))
      .then(() => this.buttonState = 'default');
    },
    onSuccess() {
      this.$emit('on-success');
    },
    onError(errors) {
      this.buttonState = 'fail';
      if (errors) {
        this.errorMessage = "Le formulaire n'est pas valide";
        for (const key in errors || {})
        this.errors[toCamel(key)] = errors[key][0];
      } else {
        this.errorMessage = "Veuillez contacter notre support technique";
      }
    },
    resetForm(brandNew) {
      this.buttonState = brandNew ? 'default' : 'inProgress';
      this.errorMessage = null;
      this.errors = {};
      if (brandNew) this.account = {};
    },
    checkInput(event) {
      this.phoneNumbersOnly = numbersOnly(event);
    },
    fillForm(data) {
      if (data) this.account.companyName = data.nomEntreprise;
    },
     showModal() {
      if (this.referrer === 'sign-up') {
        this.$modal.show(CustomModal, {
          title: 'Information',
          paragraphs: [
            'Nous vous remercions de votre demande.',
            'Celle-ci sera validée sous une heure maximum du lundi au vendredi de 08H30 à 19H00.',
            'En cas d\'urgence, vous pouvez nous contacter au 07.68.04.52.93. Après validation, nous vous adresserons à l\'adresse électronique que vous avez renseignée votre code d\'accès temporaire et vous pourrez publier en bénéficiant des avantages que nous offrons aux professionnels du droit et du chiffre. Nous vous remercions de votre confiance.',
            'Le service des Annonces Légales'
          ]
        });
      }
    }
  }
};
</script>
